import React, { useContext } from 'react';
import { Page } from '@mss/mss-component-library';
import Breadcrumbs from '../common/Breadcrumbs';
import { AppContext } from 'jsx';
import classNames from 'classnames';

export const Container = ({
  className,
  ...props
}: React.ComponentProps<'div'>) => {
  return (
    <div className={classNames('typography-container', className)} {...props} />
  );
};

function ReleaseNotes() {
  const { mssVersions } = useContext(AppContext);
  return (
    <Page
      breadCrumbs={<Breadcrumbs />}
      main={
        <Container>
          <h1>
            OpreX Managed Service Suite (MSS) release notes {mssVersions['mss_site_api']}
          </h1>
          <span>
            This version was released at <strong>2026-06-18</strong> at{' '}
            <strong>18:00 A.M. UTC</strong>
          </span>
          <h2>Component list</h2>
          <ul>
            <li>
              site-api @ <strong>{mssVersions['mss_site_api_full']}</strong>
            </li>
            <li>
              site-client @ <strong>{mssVersions['mss_site_client']}</strong>
            </li>
          </ul>
          <h2>Feature list</h2>
          Version {mssVersions['mss_site_api']} contains the following features.
          <h4 style={{ marginTop: '.5rem' }}>Assets and Applications </h4>
          <ul>
            <li>
              PLC/DCS Assets
              <ul>
                <li>
                  {' '} 
                  Add integration with Siemens SIMATIC S7
                  {' '}
                  </li>
                <ul>
                  <li> Site onboarding and data collection</li>
                  <li> Site monitors</li>
                  <li> Center detailed data display</li>
                  <li> Center dashboard widgets</li>
                </ul>
              </ul>
              <ul>
                <li>
                  {' '} 
                  Add integration with Siemens Generic
                  {' '}
                  </li>
                <ul>
                  <li> Site onboarding and data collection</li>
                  <li> Site monitors</li>
                  <li> Center detailed data display</li>
                  <li> Center dashboard widgets</li>
                </ul>
              </ul>
            </li>
            <li>
              Security Applications
              <ul>
                <li> Add vulnerability information to Nozomi Guardian </li>
                <ul>
                  <li> Site data collectors</li>
                  <li> Site monitors</li>
                  <li> Center detailed data display</li>
                  <li> Center dashboard widgets</li>
                </ul>
              </ul>
            </li>
            <li>
              Asset Management Applications - PRM
              <ul>
                <li> Add support for OPC metrics data collection for Field Assets  </li>
                <ul>
                  <li> Site configuration page added to Field Assets</li>
                  <li> Site data collector</li>
                  <li> Center detailed data display</li>
                </ul>
              </ul>
            </li>
          </ul>
          <h4>Center Dashboard </h4>
          <ul>
            <li>Updated widgets for</li>
              <ul>
              <li> Compute Assets</li>
              <ul>
                <li>
                {' '}
                Add seven new Windows Events to event related widgets
               from the security dashboard category (4648, 4723, 4724,
                4728, 4732, 4756, 5136)
                 {' '}
                 </li>
              </ul>
              <li> Security Applications - Nozomi Guardian</li>
              <ul>
                <li>
                {' '}
                Use CVSS scores &gt;= 7.0 for alerts with high criticality
                 {' '}
                 </li>
              </ul>
            </ul>
        </ul>
        <h4>Monitors</h4>
          <ul>
            <li>Updated monitors for</li>
              <ul>
              <li> Security Applications - Nozomi Guardian</li>
              <ul>
                <li>
                {' '}
                Use CVSS scores &gt;= 9.0 for critical alerts
                 {' '}
                 </li>
              </ul>
            </ul>
        </ul>
        <h4>Integrations</h4>
          <ul>
            <li>OPC Server Groups</li>
              <ul>
              <li>
                {' '}
                 Add functionality to add OPC servers to be used
                 for OPCUA related data collection{' '}
                 </li>
                 <ul>
                  <li> Siemens SIMATIC S7</li>
                  <li> Siemens Generic</li>
                  <li> Field Assets</li>
                 </ul>
                 <li> 
                  {' '}
                  OPC servers can be onboarded stand-alone or in 
                  a redundant setup {' '}
                 </li>
                 <li> 
                  {' '}
                  Connectivity from MSS to the OPC servers is
                  periodically checked{' '}
                 </li>
              <ul>
              </ul>
            </ul>
        </ul>
      <h4>Generic </h4>
          <ul>
            <li>
              {' '}
              Rename Security Applications - McAfee ePolicy Orchestrator
               to Security Applications – Trellix ePolicy Orchestrator
               {' '}
            </li>
            <li>
              {' '}
              Adjusted Field Asset Discovery flow using fields directly
              from Yokogawa’s PRM database {' '}
            </li>
            <li>
              {' '}
              Add bulk edit functionality for assets and Applications
              on Site Application{' '}
            </li>
            <li>
              {' '}
              Add bulk delete functionality for assets and applications
              on Site Application {' '}
            </li>
            <li>
              {' '}
              Split the alerts into MSS Alerts and ServiceNow Incidents
              and Cases on the Sitemap detailed page  {' '}
            </li>
            <li>
              {' '}
              Return of detailed event modals for maintenance and
              configuration events for Asset Management Applications
              – PRM and Field Assets {' '}
            </li>
            <li>
              {' '}
              Display Field Asset name for application logs for Asset
              Management Applications – PRM and Field Assets {' '}
            </li>
            <li>
              {' '}
              Add Operational Status logic to Field Assets {' '}
            </li>
            <li>
              {' '}
              Add functionality to hide default dashboard on the Center
              application dashboard page {' '}
            </li>
            <li>
              {' '}
              Adjusted Security Applications – Trellix ePolicy Orchestrator
              threat collector to no longer collect informational
              logs  {' '}
            </li>
          </ul>
          <h2>Bugs resolved </h2>
          The following bugs are resolved with the introduction of MSS{' '}
          {mssVersions['mss_site_api']}
          <h4 className="mt-4">Site and Center Application </h4>
          <ul>
            <li>
              {' '}
              Fixed a bug that caused  WEB Remote Sessions browser to crash 
              when interacting with specific Web UI components{' '}
            </li>
            <li>
              {' '}
              Fixed an issue where Administrator messages to users are not
              visible on Remote Access open requests pages {' '}
            </li>
          </ul>
          <h4>Site Application </h4>
          <ul>
            <li>
              {' '}
              Fixed an issue where some Activity Logs are not displayed
              in the expected structure{' '}
            </li>
            <li>
              {' '}
              Fixed an issue where pagination is not re-initialized when 
              navigating through different tables on the Site Status page
              {' '}
            </li>
            <li>
              {' '}
              Fixed an issue where sorting on the Site Status page tables
              was not showing expected results
              {' '}
            </li>
            <li>
              {' '}
              Fixed a bug that caused Network Assets - Connection Type
              Configuration mode to be set to 'SSH' when 'None' was 
              intended
              {' '}
            </li>
            <li>
              {' '}
              Fixed several issues where data collection records show an 
              error when unexpected data is collected {' '}
            </li>
            <li>
              {' '}
              Fixed a bug that caused Security Applications - Trellix ePO test
              connection to fail if Solidcore software was not installed
              {' '}
            </li>
            <li>
              {' '}
              Fixed a bug that caused bulk import using CSV to fail if connection
              tests are skipped for Network Assets
              {' '}
            </li>
            <li>
              {' '}
              Fixed a bug that caused the Monitor Profile category 'None' to exist
              for Network Assets
              {' '}
            </li>
          </ul>
          <h4>Center Application </h4>
          <ul>
            <li>
              {' '}
              Fixed a bug that caused dashboards with an empty name to be
              be created but not showing in the dashboard list{' '}
            </li>
            <li>
              {' '}
              Fixed an issue where some dashboard widgets show an unexpected
              amount of digits{' '}
            </li>
            <li>
              {' '}
              Fixed a bug that caused navigating from the Sitemap tables to
              a Security Application to not work {' '}
            </li>
            <li>
              {' '}
              Fixed a bug that caused drilldown from pie charts to not work
              when widget-level filters are applied {' '}
            </li>
            <li>
              {' '}
              Fixed a bug that caused COM Status from PLC/DCS Assets - BCV
              to not be displayed {' '}
            </li>
            <li>
              {' '}
              Fixed a bug that caused the Compute Asset - Disk Usage per Disk 
              dashboard widget to fail when a disk was empty {' '}
            </li>
            <li>
              {' '}
              Fixed a bug that caused the detailed view for Security
              Applications - Nozomi Alerts to not show the alert ID {' '}
            </li>
           </ul>
          <hr />
        </Container>
      }
    />
  );
}

export default ReleaseNotes;
